const config = {
    itemsPerPage: 25
};

export default config;
